var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#542F1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7118 13.1979C21.5251 12.4123 22.6145 11.9776 23.7452 11.9875C24.8759 11.9973 25.9575 12.4508 26.7571 13.2504C27.5567 14.05 28.0102 15.1316 28.02 16.2623C28.0299 17.3931 27.5952 18.4824 26.8096 19.2957L26.8028 19.3028L24.5529 21.5527C24.1157 21.99 23.5895 22.3282 23.0101 22.5443C22.4307 22.7605 21.8117 22.8495 21.1948 22.8053C20.578 22.7611 19.9779 22.5848 19.4353 22.2883C18.8926 21.9918 18.42 21.5821 18.0496 21.0869C17.8635 20.8381 17.9143 20.4856 18.1631 20.2995C18.4119 20.1135 18.7644 20.1643 18.9505 20.413C19.2242 20.7791 19.5735 21.0819 19.9746 21.301C20.3758 21.5202 20.8193 21.6505 21.2752 21.6832C21.7311 21.7158 22.1887 21.65 22.6169 21.4903C23.0452 21.3305 23.4341 21.0806 23.7572 20.7573L26.0037 18.5108C26.5823 17.91 26.9023 17.1063 26.8951 16.2721C26.8878 15.4364 26.5526 14.6369 25.9616 14.0459C25.3706 13.4549 24.5712 13.1197 23.7354 13.1124C22.9009 13.1052 22.097 13.4254 21.4961 14.0044L20.2091 15.2839C19.9888 15.5029 19.6327 15.5019 19.4136 15.2816C19.1946 15.0613 19.1956 14.7051 19.4159 14.4861L20.7118 13.1979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9898 17.4556C17.5692 17.2394 18.1883 17.1504 18.8051 17.1946C19.4219 17.2388 20.022 17.4151 20.5647 17.7116C21.1074 18.0081 21.5799 18.4178 21.9503 18.913C22.1364 19.1618 22.0856 19.5143 21.8368 19.7004C21.5881 19.8864 21.2356 19.8356 21.0495 19.5868C20.7757 19.2208 20.4264 18.918 20.0253 18.6989C19.6242 18.4797 19.1806 18.3494 18.7247 18.3167C18.2688 18.2841 17.8112 18.3499 17.383 18.5096C16.9547 18.6694 16.5659 18.9193 16.2427 19.2426L13.9962 21.4891C13.4177 22.0899 13.0976 22.8936 13.1049 23.7278C13.1121 24.5635 13.4473 25.363 14.0383 25.954C14.6293 26.545 15.4288 26.8802 16.2645 26.8875C17.0987 26.8947 17.9024 26.5747 18.5033 25.9961L19.7822 24.7172C20.0018 24.4975 20.358 24.4975 20.5777 24.7172C20.7973 24.9368 20.7973 25.293 20.5777 25.5127L19.2882 26.8021C18.4749 27.5876 17.3855 28.0223 16.2548 28.0124C15.124 28.0026 14.0424 27.5491 13.2428 26.7495C12.4433 25.9499 11.9897 24.8683 11.9799 23.7376C11.9701 22.6068 12.4047 21.5175 13.1903 20.7041L13.1971 20.6971L15.4471 18.4472C15.4471 18.4473 15.4471 18.4472 15.4471 18.4472C15.8843 18.0099 16.4104 17.6717 16.9898 17.4556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeLink);
export default __webpack_public_path__ + "static/media/Type=Link.d661fb25ffeaf10833f0b423b1bea201.svg";
export { ForwardRef as ReactComponent };